<script lang="ts">
	import {
		addWeeks,
		isSameWeek,
		isThisMonth,
		isThisWeek,
		isThisYear,
		isToday,
		isYesterday
	} from 'date-fns';

	import { page } from '$app/state';

	import * as Sidebar from '$lib/components/ui/sidebar';

	import type { Chat } from '$lib/client/db/schema';
	import * as m from '$lib/paraglide/messages';
	import { cn } from '$lib/utils';

	let { chats }: { chats: Chat[] } = $props();

	const lastWeek = addWeeks(new Date(), -1);
	const groupDefs = [
		{
			title: m.recentChats_today(),
			predicate: (chat: Chat) => isToday(chat.updatedAt)
		},
		{
			title: m.recentChats_yesterday(),
			predicate: (chat: Chat) => isYesterday(chat.updatedAt)
		},
		{
			title: m.recentChats_thisWeek(),
			predicate: (chat: Chat) => isThisWeek(chat.updatedAt)
		},
		{
			title: m.recentChats_lastWeek(),
			predicate: (chat: Chat) => {
				return isSameWeek(chat.updatedAt, lastWeek);
			}
		},
		{
			title: m.recentChats_thisMonth(),
			predicate: (chat: Chat) => isThisMonth(chat.updatedAt)
		},
		{
			title: m.recentChats_thisYear(),
			predicate: (chat: Chat) => isThisYear(chat.updatedAt)
		},
		{
			title: m.recentChats_lastYear(),
			predicate: (chat: Chat) => chat.updatedAt.getFullYear() === new Date().getFullYear() - 1
		},
		{
			title: m.recentChats_older(),
			predicate: () => true
		}
	];

	const groups = $derived.by(() => {
		const groups = groupDefs.map((def) => ({
			...def,
			chats: [] as Chat[]
		}));

		for (const chat of chats) {
			for (const group of groups) {
				if (group.predicate(chat)) {
					group.chats.push(chat);
					break;
				}
			}
		}

		return groups;
	});
</script>

{#if chats.length > 0}
	<Sidebar.Menu>
		{#each groups as group (group)}
			{#if group.chats.length > 0}
				<Sidebar.Group class="py-0">
					<Sidebar.GroupLabel class="opacity-50">{group.title}</Sidebar.GroupLabel>

					<Sidebar.GroupContent class="pl-2">
						<Sidebar.Menu>
							{#each group.chats as chat (chat)}
								{@const isActive = page.url.pathname.startsWith(`/collections/chats/${chat.id}`)}

								<Sidebar.MenuItem>
									<Sidebar.MenuButton
										size="sm"
										{isActive}
										class={cn(
											'transition-all',
											isActive && 'border-l-2 ml-2 pl-2 border-muted bg-transparent! font-semibold!'
										)}
									>
										{#snippet child({ props })}
											<a
												href="/collections/chats/{chat.id}#bottom"
												{...props}
												title={chat.title.trim() || m.untitledChat_title()}
											>
												<span>{chat.title.trim() || m.untitledChat_title()}</span>
											</a>
										{/snippet}
									</Sidebar.MenuButton>
								</Sidebar.MenuItem>
							{/each}
						</Sidebar.Menu>
					</Sidebar.GroupContent>
				</Sidebar.Group>
			{/if}
		{/each}
	</Sidebar.Menu>
{/if}
